(ns ncr.sidebar
  (:require
   [clojure.core.match :refer [match]]
   [cljs.core.async :as async :refer-macros [go]]
   [uix.core.alpha :as uix]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.util :as u]
   [ncr.widgets.core :as w]
   [ncr.etc.pf :as pf]
   [ncr.etc.profile :as profile]
   [ncr.amplitude :as amp]
   [ncr.me :as me]
   [ncr.navigate :as n]
   [ncr.fragment-types.attachments :as fragment-attachments]
   [ncr.sidebar.labels :as labels]
   [ncr.sidebar.folders :as folders]
   [ncr.sidebar.common :as common]))

(def default-props
  {:on-click
   (fn [_ {:keys [query]}]
     (amp/search!
       {"Query" query
        "Origin" "Sidebar"})
     (n/push-search! query))

   :on-ctrl-click
   (fn [_ {:keys [query]}]
     (amp/search!
       {"Query" query
        "Origin" "Sidebar"
        "Modify" "Toggle"})
     (ps/pub! [:query/toggle query]))})

(defn- on-drop-accepted [folder files]
  (go
    (let
      [all
       (<!
         (->> files
           (map
             (fn [file]
               (fragment-attachments/!create-fragment
                 {:name (fragment-attachments/default-fragment-name file)
                  :files [file]
                  :folder (:id folder)
                  :tentative true})))
           (async/merge)
           (async/into [])))]
      (u/when-ok
        [_ all]
        (ps/pub! [:search/execute false])
        (ps/pub! [:me/load])))))

(defn c-sidebar []
  (let
    [{:keys [cluster roles] :as me} (uix/context me/*context*)
     p-sections (profile/use-profile [:local "ui/sidebar/sections"] {})
     p-pinned (profile/use-profile [:remote "ui/sidebar/pinned"] #{})]

    (letfn
      [(use-expanded-section [section default]
         (let [is-expanded (get-in @p-sections [:expanded section] default)]
           {:is-expanded is-expanded
            :on-expand (fn [_] (swap! p-sections assoc-in [:expanded section] (not is-expanded)))}))]

      (when @p-sections
        [pf/c-page-sidebar
         {:data-tour-target "sidebar"
          :nav
          [pf/c-nav
           [pf/c-nav-list
            [common/c-section
             {:icon :folder-multiple-outline
              :label "Incoming"
              :inner-props (use-expanded-section :folders true)}

             [:<>
              [folders/c-folder
               (merge default-props
                 {:icon :folder-outline
                  :drop-accepted? true
                  :on-drop-accepted on-drop-accepted
                  :data-tour-target "inbox"})
               (folders/model (me/inbox-folder me))]

              (for [{:keys [id] :as folder} (->> (me/shared-folders me) (map folders/model) (sort-by :label))]
                ^{:key id}
                [folders/c-folder
                 (merge default-props
                   {:icon :folder-account-outline
                    :drop-accepted? true
                    :on-drop-accepted on-drop-accepted})
                 folder])

              [folders/c-folder
               (merge default-props
                 {:icon :trash-can-outline
                  :drop-accepted? false})
               (folders/model (me/trash-folder me))]]]

            [common/c-section
             {:icon :tag-outline
              :label "Labels"
              :inner-props
              (merge
                (use-expanded-section :labels false)
                {:class :ncr-c-nav-list__labels})}

             (let
               [{:keys [pinned unpinned]}
                (->> (:labels cluster)
                  (labels/model)
                  (group-by
                    (fn [{:keys [id]}]
                      (if (contains? @p-pinned id) :pinned :unpinned))))]
               [:<>
                (for [{:keys [id] :as label} pinned]
                  ^{:key id}
                  [labels/c-label
                   (merge default-props
                     {:pinned? true :on-pin-click #(swap! p-pinned disj id)})
                   label])

                (when (and (seq unpinned) (seq pinned))
                  [pf/c-nav-item-separator])

                (for [{:keys [id] :as label} unpinned]
                  ^{:key id}
                  [labels/c-label
                   (merge default-props
                     {:pinned? false :on-pin-click #(swap! p-pinned conj id)})
                   label])])]

            (when (contains? roles :manager)
              [common/c-sidebar-item
               {:on-click
                #(do
                   (amp/navigate! {"Origin" "Sidebar" "Destination" "Reports"})
                   (n/push-state! :reports))
                :href (n/href :reports)}
               [:span [w/c-mdi-icon {:icon :table}]
                [:span.pf-u-pl-sm "Reports"]]])

            (when (contains? roles :administrator)
              [common/c-section
               {:icon :cog-outline
                :label "Management"
                :inner-props (use-expanded-section :management false)}
               (for
                 [{:keys [label route track-target]}
                  [{:label "Accounts" :route :manage-accounts :track-target "Manage Accounts"}
                   {:label "Labels" :route :manage-labels :track-target "Manage Labels"}
                   {:label "Shared Folders" :route :manage-folders :track-target "Manage Folders"}
                   {:label "AI Assist" :route :manage-assist :track-target "Manage AI Assist"}
                   {:label "DATEV" :route :manage-datev :track-target "Manage DATEV"}]]
                 ^{:key route}
                 [common/c-sidebar-item
                  {:on-click
                   #(do
                      (amp/navigate! {"Origin" "Sidebar" "Destination" track-target})
                      (n/push-state! route))
                   :href (n/href route)}
                  label])])]]}]))))
